import { defineMessages } from "react-intl";

export const pluginsFilterErrorMessages = defineMessages({
  active: {
    id: "T/dYnE",
    defaultMessage: "Status is not selected",
    description: "plugin filters error messages status",
  },
  channels: {
    id: "gZHmaV",
    defaultMessage: "No channels selected",
    description: "plugin filters error messages channels",
  },
});

export const pluginsListPageMessages = defineMessages({
  appStoreWarning: {
    defaultMessage: "We are working on replacing plugins with apps. Read more about",
    id: "yfhLcv",
  },
  warningHeadline: {
    defaultMessage: "Warning",
    id: "3SVI5p",
  },
});
